import { render } from "./PricingIncreaseAdminPage.vue?vue&type=template&id=5cf1e79a&scoped=true"
import script from "./PricingIncreaseAdminPage.vue?vue&type=script&lang=js"
export * from "./PricingIncreaseAdminPage.vue?vue&type=script&lang=js"

import "./PricingIncreaseAdminPage.vue?vue&type=style&index=0&id=5cf1e79a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf1e79a"]])

export default __exports__